// import React from 'react'
// import './Achievements.scss';
// const Achievements = () => {
//   return (
//     <div>Achievements</div>
//   )
// }

// export default Achievements


import React, { useState, useEffect } from 'react';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';
import { motion } from 'framer-motion';
import { images } from '../../constants';   

import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';
import './Achievements.scss';

const Achievements = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [testimonials, setTestimonials] = useState([]); 
  const [brands, setBrands] = useState([]);

  const handleClick = (index) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    const query = '*[_type == "testimonials"]';
    const brandsQuery = '*[_type == "brands"]';

    client.fetch(query).then((data) => {
      setTestimonials(data);
    });

    client.fetch(brandsQuery).then((data) => {
      setBrands(data);
    });
  }, []);

  return (
    <>
    <h2 className="head-text">My crazy <span>Achievements</span> !</h2>
    <div className='space'/>
      {testimonials.length && (
        <>
          <div className="app__testimonial-item app__flex">
              <a href={testimonials[currentIndex].url} target="_blank" rel="noreferrer">
                <img className='bg' src={urlFor(testimonials[currentIndex].imgurl)} alt={testimonials[currentIndex].name} />
              </a>
            <div className="app__testimonial-content">
              <p className="p-text">{testimonials[currentIndex].feedback}</p>
              <div>
                <h4 className="bold-text">{testimonials[currentIndex].name}</h4>
              </div>
            </div>
          </div>

          <div className="app__testimonial-btns app__flex">
            <div className="app__flex" onClick={() => handleClick(currentIndex === 0 ? testimonials.length - 1 : currentIndex - 1)}>
              <HiChevronLeft />
            </div>
            <div id="count">
              <h2>{currentIndex+1} / {testimonials.length}</h2>
            </div>
            <div className="app__flex" onClick={() => handleClick(currentIndex === testimonials.length - 1 ? 0 : currentIndex + 1)}>
              <HiChevronRight />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AppWrap(
  MotionWrap(Achievements, 'app__testimonial'),
  'Achievements',
  'app__primarybg',
);